import React, { useCallback, useEffect } from 'react';
import { Pane, Radio } from '@leverege/ui-elements';
import { jsx as _jsx } from "react/jsx-runtime";
const options = [{
  label: 'Indoors',
  value: 'indoors'
}, {
  label: 'Outdoors',
  value: 'outdoors'
}];
export default function ZoneEnvironmentEditor(props) {
  const {
    onChange: pOnChange,
    eventData
  } = props;
  const getValue = () => {
    const {
      value
    } = props;
    return value;
  };
  const value = getValue();
  const onChange = useCallback(evt => {
    const {
      data: {
        value
      }
    } = evt;
    const toSend = {
      value,
      data: eventData
    };
    pOnChange?.(toSend);
  }, [eventData, pOnChange]);
  useEffect(() => {
    if (value == null) {
      pOnChange({
        value: 'outdoors',
        data: eventData
      });
    }
  }, []);
  const style = {
    marginBottom: '20px'
  };
  return /*#__PURE__*/_jsx(Pane, {
    layout: "flex:colS",
    style: style,
    children: options.map(opt => /*#__PURE__*/_jsx(Radio, {
      variant: "zoneEnvironment",
      eventData: opt,
      label: opt.label,
      on: opt.value,
      value: value,
      onChange: onChange
    }, opt.value))
  });
}